import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { useMediaQuery } from './media-query';
export const useScreenSize = () => {
    const { screen } = useContext(ThemeContext);
    // Mobile
    const isMobileQuery = `(max-width: ${screen === null || screen === void 0 ? void 0 : screen.smMax})`;
    const { matches: isMobile } = useMediaQuery(isMobileQuery);
    // Tablet portrait
    const isTabletPortraitQuery = `(min-width: ${screen === null || screen === void 0 ? void 0 : screen.mdMin}) and (max-width: ${screen === null || screen === void 0 ? void 0 : screen.mdMax})`;
    const { matches: isTabletPortrait } = useMediaQuery(isTabletPortraitQuery);
    // Tablet landscape
    const isTabletLandscapeQuery = `(min-width: ${screen === null || screen === void 0 ? void 0 : screen.lgMin}) and (max-width: ${screen === null || screen === void 0 ? void 0 : screen.lgMax})`;
    const { matches: isTabletLandscape } = useMediaQuery(isTabletLandscapeQuery);
    // Desktop
    const isDesktopQuery = `(min-width: ${screen === null || screen === void 0 ? void 0 : screen.xlMin})`;
    const { matches: isDesktop } = useMediaQuery(isDesktopQuery);
    return { isMobile, isTabletPortrait, isTabletLandscape, isDesktop };
};
